// extracted by mini-css-extract-plugin
export default {"RoleFormRoot":"RoleFormRoot---a6w8N","alignRightWrapper":"alignRightWrapper---ZXkYn"};